module.exports = __webpack_public_path__ + "static/media/payroll-reimbursement.497eea55.png";